/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { BreakPoint } from '../../../../asset/styles';
import BodyCheckboxWithLabel from './checkboxes/BodyCheckboxWithLabel';

const StyledField = styled.div`
  margin-top: 24px;
  padding-left: 16px;
  padding-right: 16px;

  &:first-child {
    /*margin-top: 16px;*/
    margin: 16px 0;
  }

  @media (min-width: ${BreakPoint.desktop}) {
    margin-top: 12px;

    &:first-child {
      margin-top: 10px;
    }
  }
`;

/**
 * {@link Inquiry} 設問 checkbox 親 component
 * @param {Array<{label: string, name: string, value: string}>} options checkbox 作成 data
 * @param {*} props React.props
 * @return {*} React.node - {@link Inquiry} 設問 checkbox 親 component
 * @constructor
 */
const BodyCheckboxes = ({ options, ...props }) => (
  <StyledField className={'BodyCheckboxes'}>
    {options
      .filter(option => option.label !== '')
      .map((option, index) => (
        // !console.log('BodyCheckboxes - props', index, props, option) &&
        <BodyCheckboxWithLabel
          key={`inquiry-checkbox-${index}`}
          id={`inquiry-checkbox-${index}`}
          name={option.name}
          label={option.label}
          value={option.value}
          {...props}
        />
      ))}
  </StyledField>
);

export default BodyCheckboxes;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/body/BodyCheckboxes.js